export const EXCHANGE_REQUEST = 'EXCHANGE_REQUEST'
export const EXCHANGE_RECEIVE = 'EXCHANGE_RECEIVE'